export const buildDetailRowId = (rowId, data) => `${rowId}-${data.id}`
